import { useEffect } from "react";
import "../Styles/get_certified.css";
import { useNavigate } from "react-router-dom";







function GetCertificate() {
   const navigate = useNavigate();
    useEffect(() => {
    document.title = "Get Certificate | Outstanding Workplaces";
  }, []);
  return (
    <>
      {/* ===== FIRST SECTION ===== */}
      <section className="getcert">

        {/* LEFT CONTENT */}
        <div className="getcert-left">
          <h1 className="getcert-title">
            When candidates compare offers,<br />
            culture wins.
          </h1>
          <p className="getcert-desc">
            Outstanding Workplaces Certification helps you attract, engage, and retain top talent.
          </p>
         <button 
  className="getcert-btn"
  type="button"
  onClick={() => {
    navigate('/nominate');
    window.scrollTo(0, 0);
  }}
>
  <img
    src="/assets/badge_get_certificate.png"
    alt="badge"
    className="getcert-icon"
  />
  Get Certificate
</button>
        </div>

        {/* RIGHT IMAGE */}
        <div className="getcert-right">
          <img src="/assets/get_certificate1.png" alt="team" />
        </div>

      </section>

      {/* ===== SECOND SECTION ===== */}
      <section className="get_workplace">
        

        {/* LEFT — Sticky Heading */}
        <div className="get_workplace-left">
          <h2 className="get_workplace-title">
            What Makes an<br />
            Outstanding Workplace?
          </h2>
        </div>

        {/* RIGHT — 4 Cards */}
        <div className="get_workplace-right">

          {/* CARD 1 */}
          <div className="get_workplace-card card-one">
            <div className="get_icon-box icon-one">
             <img 
  src="/assets/get_icon_01.png" 
  alt="icon 1" 
  className="get_card-icon-img" 
/>
            </div>
            <p className="get_card-one-text">
              Outstanding Workplaces Certification recognizes organizations that excel in workplace culture, employee engagement, and people practices. It highlights companies committed to employee well-being and a positive work environment.
            </p>
          </div>

          {/* CARD 2 */}
          <div className="get_workplace-card card-two">
            <div className="get_icon-box icon-two">
             <img 
  src="/assets/get_icon_02.png" 
  alt="icon 2" 
  className="get_card-icon-img" 
/>
            </div>
            <p className="get_card-two-text">
              The certification evaluates leadership, policies, diversity & inclusion, and overall employee satisfaction. It reflects how well an organization aligns its values with employee experience.
            </p>
          </div>

          {/* CARD 3 */}
          <div className="get_workplace-card card-three">
            <div className="get_icon-box icon-three">
             <img 
  src="/assets/get_icon_03.png" 
  alt="icon 3" 
  className="get_card-icon-img" 
/>
            </div>
            <p className="get_card-three-text">
              Earning this certification helps organizations build a strong employer brand and stand out in a competitive job market. It signals to potential candidates that the company is a great place to work and grow.
            </p>
          </div>

          {/* CARD 4 */}
          <div className="get_workplace-card card-four">
            <div className="get_icon-box icon-four">
              <img 
  src="/assets/get_icon_04.png" 
  alt="icon 4" 
  className="get_card-icon-img" 
/>
            </div>
            <p className="get_card-four-text">
              Ultimately, Outstanding Workplaces Certification not only attracts top talent but also boosts employee morale, retention, and organizational performance, contributing to long-term business success.
            </p>
          </div>

        </div>

      </section>

      {/* ===== THIRD SECTION — HOW TO ACHIEVE ===== */}
      <section className="achieve">

        {/* SECTION HEADING — centered */}
        <h2 className="achieve-title">How to Achieve Certification?</h2>

        {/* STEP 1 — text left, image right */}
        <div className="achieve-row achieve-row-one">

          {/* LEFT — step text */}
          <div className="achieve-text achieve-text-one">

            {/* BADGE + GRADIENT LINE — step 1 */}
            <div className="achieve-badge-row">
              <div className="achieve-step-badge achieve-badge-one">01</div>
              <div className="achieve-badge-line"></div>
            </div>

            <h3 className="achieve-step-title achieve-step-title-one">
              Engage Employees Through Surveys
            </h3>
            <p className="achieve-step-desc achieve-step-desc-one">
              Collect honest feedback from your employees to understand their
              experiences, satisfaction levels, and areas for improvement.
            </p>
          </div>

          {/* RIGHT — image */}
          <div className="achieve-img-wrap achieve-img-wrap-one">
            <img
  src="/assets/get_image_01.png"
  alt="Engage Employees"
  className="achieve-img achieve-img-one"
/>
          </div>

        </div>

        {/* STEP 2 — image left, text right */}
        <div className="achieve-row achieve-row-two">

          {/* LEFT — image */}
          <div className="achieve-img-wrap achieve-img-wrap-two">
            <img
  src="/assets/get_image_02.png"
  alt="Define Workplace Culture"
  className="achieve-img achieve-img-two"
/>
          </div>

          {/* RIGHT — step text */}
          <div className="achieve-text achieve-text-two">

            {/* BADGE + GRADIENT LINE — step 2 */}
            <div className="achieve-badge-row">
              <div className="achieve-step-badge achieve-badge-two">02</div>
              <div className="achieve-badge-line"></div>
            </div>

            <h3 className="achieve-step-title achieve-step-title-two">
              Define Your Workplace Culture Insights
            </h3>
            <p className="achieve-step-desc achieve-step-desc-two">
              Outline your organization's values, practices, and culture to
              showcase what makes your workplace unique.
            </p>
          </div>

        </div>

        {/* STEP 3 — text left, image right */}
        <div className="achieve-row achieve-row-three">

          {/* LEFT — step text */}
          <div className="achieve-text achieve-text-three">

            {/* BADGE + GRADIENT LINE — step 3 */}
            <div className="achieve-badge-row">
              <div className="achieve-step-badge achieve-badge-three">03</div>
              <div className="achieve-badge-line"></div>
            </div>

            <h3 className="achieve-step-title achieve-step-title-three">
              Promote Your Certified Workplace Brand
            </h3>
            <p className="achieve-step-desc achieve-step-desc-three">
              Highlight your certification across platforms to build credibility,
              attract talent, and strengthen your employer brand.
            </p>
          </div>

          {/* RIGHT — image */}
          <div className="achieve-img-wrap achieve-img-wrap-three">
            <img
  src="/assets/get_image_03.png"
  alt="Promote Brand"
  className="achieve-img achieve-img-three"
/>
          </div>

        </div>

      </section>
    </>
  );
}

export default GetCertificate;